import sal from 'sal.js';
document.addEventListener("DOMContentLoaded", function(){
    sal();    
});


